<template>
  <div class="w-full relative z-30">
    <label v-if="label" class="block text-sm font-bold text-gray-700 mb-2">
      {{ label }}
    </label>

    <div class="flex items-stretch shadow-sm">
      <!-- Country Code Dropdown -->
      <CountryCodeDropdown
        :value="selectedCountry"
        @input="$emit('update:country', $event)"
      />

      <!-- Phone Number Input -->
      <div class="relative flex-grow">
        <input
          ref="input"
          type="tel"
          :value="value"
          @input="onInput"
          :placeholder="placeholder"
          :disabled="disabled"
          class="w-full h-full rounded-r-xl border border-gray-200 bg-gray-50 px-4 py-3 text-gray-900 placeholder-gray-400 outline-none transition-all focus:bg-white focus:border-primary-500 focus:ring-2 focus:ring-primary-200 disabled:bg-gray-100 disabled:text-gray-400"
          :class="{
            'border-red-400 focus:border-red-500 focus:ring-red-200':
              error && errorMessage
          }"
        />
      </div>
    </div>

    <p v-if="error && errorMessage" class="mt-1 text-xs text-red-500">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import CountryCodeDropdown from "./CountryCodeDropdown.vue";

export default {
  name: "PhoneInput",
  components: {
    CountryCodeDropdown
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    selectedCountry: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  methods: {
    onInput(event) {
      // Force only digits
      const originalValue = event.target.value;
      const digitsOnly = originalValue.replace(/\D/g, "");

      // Update input field immediately if needed to prevent non-digits from appearing
      if (originalValue !== digitsOnly) {
        event.target.value = digitsOnly;
      }

      this.$emit("input", digitsOnly);
    }
  }
};
</script>
